import { http, HttpResponse } from 'msw'

interface MockGetContractPressginedURLPathParams {
  alphaId: string
}

export const mockGetContractPressignedURL =
  http.post<MockGetContractPressginedURLPathParams>(
    '/my-business/api/agency/v1/contracts/:alphaId/contracts',
    () => {
      return HttpResponse.json(
        { preSignedUrl: '/api/agency/v1/agency-chains/upload-contract' },
        { status: 200 },
      )
    },
  )
